import {
  UPDATE_CUSTOM_PAYMENT_DATA,
  GETTING_CUSTOM_PAYMENT_LINK,
  SET_CUSTOM_PAYMENT_ERRORS,
  RESET_CUSTOM_PAYMENT,
} from '../../../../types/conversations/plugins'
import apiConversation from 'api/conversation'

const paymentApi = apiConversation.plugins.payment

const updateData = (userId, data) => (dispatch) => {
  return dispatch({
    userId,
    data,
    type: UPDATE_CUSTOM_PAYMENT_DATA,
  })
}

const gettingCustomPaymentLink = (userId, gettingLink = true) => ({
  userId,
  gettingLink,
  type: GETTING_CUSTOM_PAYMENT_LINK,
})

const setCustomPaymentErrors = (userId, errors = {}) => ({
  userId,
  errors,
  type: SET_CUSTOM_PAYMENT_ERRORS,
})

const resetCustomPayment = (userId) => (dispatch) => {
  return dispatch({
    userId,
    type: RESET_CUSTOM_PAYMENT,
  })
}

const createLink = (user, price, concept, bondNumber) => (dispatch) => {
  // set getting link and remove previous errors
  dispatch(gettingCustomPaymentLink(user.id))
  dispatch(setCustomPaymentErrors(user.id))

  paymentApi
    .getCustomPaymentLink({ user, data: { concept, price, bondNumber } })
    .then(({ data, status }) => {
      dispatch(gettingCustomPaymentLink(user.id, false))

      const { link, value: price, commission, total, currency } = data.results
      const customPaymentData = { link, price, total, commission, currency }
      return dispatch(updateData(user.id, customPaymentData))
    })
    .catch(({ response = {} }) => {
      const data = response.data || {}

      dispatch(gettingCustomPaymentLink(user.id, false))
      return dispatch(setCustomPaymentErrors(
        user.id, { [data.field || 'global']: data.type || 'generic_error' }
      ))
    })
}

export default {
  updateData,
  createLink,
  resetCustomPayment,
}